import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/feature/SEO';
function App() {
  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <SEO />
          <AppRoutes />
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  );
}

export default App;
